<template>
    <div class="google__map">
        <GmapMap :center="coords" :zoom="12" style="width: 100%; height: 100%" ref="map">
            <GmapMarker
                    :position="coords"
                    :clickable="false"
                    :draggable="true"
            />
        </GmapMap>
    </div>
</template>

<script>
    export default {
        name:  'GoogleMapContainer',
        props: ['coords']
    }
</script>



// WEBPACK FOOTER //
// src/components/google-map/Map.vue